export enum VenueAnalysisStreamElementType {
    MSG = 100,
    ORDERINFO = 102,
    QTYINFO = 103,
    FILLINFO = 104,
    MKTVOLHIST = 105,
    MKTVOLRT = 106,
}
